import DonationAmountSum from './DonationAmountSum'

export default DonationAmountSum
